import { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import TheLayout from './containers/TheLayout';
import { localStorageUtils } from '../utils/storageUtils';
import { useAppDispatch } from '../redux/hooks';
import { setUser } from '../redux/slices/userSlice';
import { useAppSelector } from '../redux/hooks';
import { UserInfo } from '../datatypes/UserInfo';
import { ScrollProvider } from './context/ScrollContext';

function App() {
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector((state) => state.metadata);
  const currentUser: UserInfo | null = useAppSelector(
    (select) => select.user.currentUser,
  );

  useEffect(() => {
    const userState = localStorageUtils.getInitialUserState();
    if (userState) {
      if (!currentUser) {
        dispatch(setUser(userState.user));
      }
    }
    // if (loading) {
    //   dispatch(fetchPagesMetadata());
    // }
  }, [loading, dispatch]);

  return (
    <ScrollProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/*" Component={TheLayout} />
        </Routes>
      </BrowserRouter>
    </ScrollProvider>
  );
}

export default App;
